<template>
  <Layout :company="model">
		<div class="text-center loaderko" v-if="loading">
			<div class="spinner-grow text-primary m-2" role="status">
				<span class="sr-only">Loading...</span>
			</div>
			<div class="text-muted small">Loading</div>
		</div>
		<div class="card p-4 col-md-8 mx-auto mt-4">
			<div class="text-center alert alert-success" v-if="application.offer_accepted">
				Thank you accepting the job offer.
			</div>
			<div class="mb-3 " v-if="!application.offer_accepted">
				<button class="btn2 btn2-primary btn2-md float-right ml-2" @click="onAccept"><i class="uil-message"></i> Accept</button> 
				<button class="btn btn-soft-danger float-right ml-2" @click="onDecline">Decline</button>
			</div>
			<div class="h5 my-1">Job Reference: #{{application.job_id.reference_no}}</div>
			<div class="h6 text-muted my-1">Candidate: {{application.candidate_id.full_name}}</div>
			<div class="h6 text-muted my-1">Job Title: {{application.job_id.title}}</div>
			<div class="h6 text-muted my-1">Job Salary Offer: {{application.offer_salary.$numberDecimal | 
				currency(application.job_id.currency_id.symbol, application.job_id.currency_id.symbol == '¥' ? 0 : 2) }}</div>
			<hr>
			<p style="white-space:pre-wrap">
				{{application.offer_description}}
			</p>

		</div>
  </Layout>
</template>

<script>
import Layout from '@layouts/basic'
import { mapActions } from 'vuex'
import moment from 'moment/moment'
import  FormMixin from '@mixins/form'

export default {
	mixins:[FormMixin],
	name: 'Login',
	data() {
		return {
			model:{
				date:'',
				time:'',
				selected:''
			},
			times: [],
			selected_times:{},
			application:{
				candidate_id:{},
				job_id:{}
			},
			start_time:'',
			end_time:'',
			dates:[],
			options:{
				inline:true,
				enable:[]
			}
		}
	},
	methods:{
		...mapActions('candidate', ['getApplication', 'acceptOffer', 'declineOffer']),
		onAccept(){

			this.$bvModal.msgBoxConfirm(
				`Are you sure you want to accept Job Offer?`, 
			{
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'ACCEPT OFFER',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
					this.toggleLoading()
					this.acceptOffer({
						id:this.application._id
					}).then(res => {
						if(res.data){
							this.$bvToast.toast(`Job Offer has been accepted.`, {
								title: 'Notification',
								variant:'success'
							})
							this.application = res.data
						}

						this.toggleLoading()
					})
        }
      })
		},
		onDecline(){
			this.$bvModal.msgBoxConfirm('Are you sure you want to decline Job Offer?', {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'DECLINE JOB OFFER?',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
					this.toggleLoading()
					this.declineOffer({
						id:this.application._id
					}).then(res => {
						if(res.data){
							this.$bvToast.toast(`You've successfully decline the job offer.`, {
								title: 'Notification',
								variant:'success'
							})
							this.application = res.data
						}

						this.toggleLoading()
					})
        }
      })
		},
	},
	components: { Layout },
	filters:{
    date:function(v){
      return v ? moment(v).format('MMM DD, YYYY') : 'N/A'
    }
	},
	async beforeMount() {
		await this.getApplication({
			token:this.$route.query.key
		}).then(res => {
			this.application = res.data
		})

	}
}
</script>

<style lang="scss">
.flatpickr-calendar{
	margin:auto;
}
.flatpickr-disabled{
	color: #dfdfdf !important;
	font-weight: normal !important;
}
.flatpickr-day{
	color: green;
	font-weight: 900;
}
.loaderko{
  position: absolute;
  height: 100%;
  z-index: 9;
  background: #ffffffc7;
  width: 100%;
  /* vertical-align: middle; */
  /* margin: auto; */
}
</style>

